module.exports = __webpack_public_path__ + "static/img_1893-1690cd302e306ea9f8dcc114ef20629c.webp";